module.exports = {"450703001":"长田街道","450703002":"鸿亭街道","450703003":"子材街道","450703100":"大垌镇","450703101":"平吉镇","450703102":"青塘镇","450703103":"小董镇","450703104":"板城镇","450703105":"那蒙镇","450703106":"长滩镇","450703107":"新棠镇","450703108":"大直镇","450703109":"大寺镇","450703110":"贵台镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450703.json
// module id = 2253
// module chunks = 0